<template>
  <div class="fixed top-0 left-0 w-full h-dvh flex justify-center items-center bg-stone-800/75">
    <svg class="
      animate-spin
      h-14 w-14
      border-4
      border-t-gray-100
      border-r-stone-400
      border-b-stone-400
      border-l-stone-400
      rounded-full"
         viewBox="0 0 24 24"
    >
    </svg>
  </div>
</template>

